import { render, staticRenderFns } from "./registrationAdmin.vue?vue&type=template&id=76c43fc1&scoped=true"
import script from "./registrationAdmin.vue?vue&type=script&lang=js"
export * from "./registrationAdmin.vue?vue&type=script&lang=js"
import style0 from "./registrationAdmin.vue?vue&type=style&index=0&id=76c43fc1&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c43fc1",
  null
  
)

export default component.exports